import React, { useRef, useState } from "react";
import PageHero from "./PageHero";
import emailjs from "@emailjs/browser";
import img13 from "../../media/images/garary/FH_UG-531.jpg";

function Contact() {
  const form = useRef();

  // LOADING STATE
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    // DISABLE BUTTON
    setLoading(true);

    emailjs
      .sendForm(
        "service_kmkcgs3",
        "template_c3asdce",
        form.current,
        "RbnxvBNkLv2JZlm7o"
      )
      .then(
        () => {
          alert("Message sent successfully ✅");
          form.current.reset();

          // ENABLE BUTTON AGAIN
          setLoading(false);
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send ❌");

          // ENABLE BUTTON AGAIN
          setLoading(false);
        }
      );
  };

  return (
    <>
      <PageHero
        title="Contact Us"
        subtitle="Get in touch with Father’s House Church Resort Hotel"
        image={img13}
      />

      <div className="container py-5">
        <h2 className="text-center mb-4">Contact Us</h2>

        <div className="row">
          {/* CONTACT FORM */}
          <div className="col-md-6 mb-4">
            <div className="card shadow p-4">
              <h4 className="mb-3">Send Message</h4>

              <form ref={form} onSubmit={sendEmail}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    placeholder="Full Name"
                    required
                  />
                </div>

                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    placeholder="Email Address"
                    required
                  />
                </div>

                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    placeholder="Subject"
                    required
                  />
                </div>

                <div className="mb-3">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="4"
                    placeholder="Your Message"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-success w-100 d-flex justify-content-center align-items-center"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Sending...
                    </>
                  ) : (
                    "Send Message"
                  )}
                </button>
              </form>
            </div>
          </div>

          {/* CONTACT DETAILS */}
          <div className="col-md-6 mb-4">
            <div className="card shadow p-4 mb-4">
              <h4>Contact Information</h4>
              <p>
                <strong>Phone:</strong> +256 775 203734
              </p>
              <p>
                <strong>Email:</strong> info@fathershouseuganda.com
              </p>
              <p>
                <strong>Location:</strong> Mutungo Hill, Lubowa Wakiso
                District, Uganda
              </p>
            </div>

            {/* GOOGLE MAP */}
            <div className="card shadow">
              <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d719.5129546545455!2d32.57478448211151!3d0.21493658087023637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMMKwMTInNTQuMCJOIDMywrAzNCczMC44IkU!5e1!3m2!1sen!2sug!4v1776860091082!5m2!1sen!2sug"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;